/* ============================================================
   WORKSHOP GALLERY — section-product-showcase.js
   Desktop : full-viewport 3-up drag carousel
             centre caption animates in, ghost number bottom-right
   Mobile  : exact original image-trail 3D coverflow (GSAP)
   ============================================================ */
(function () {
  'use strict';

  var section = document.querySelector('[data-wg]');
  if (!section) return;

  var isMobile = window.innerWidth < 900;
  window.addEventListener('resize', function () { isMobile = window.innerWidth < 900; });

  /* ================================================================
     DESKTOP — drag carousel
  ================================================================ */
  function initDesktop() {
    if (isMobile) return;

    var track      = section.querySelector('[data-wg-track]');
    var trackWrap  = section.querySelector('[data-wg-track-wrap]');
    var cards      = Array.from(section.querySelectorAll('[data-wg-card]'));
    var dots       = Array.from(section.querySelectorAll('[data-wg-dot]'));
    var counterEl  = section.querySelector('[data-wg-current]');
    var ghostEl    = section.querySelector('[data-wg-ghost]');
    var centreLabel  = section.querySelector('[data-wg-centre-label]');
    var centreCap    = section.querySelector('[data-wg-centre-caption]');
    var centreInfo   = section.querySelector('[data-wg-centre-info]');
    var infoNodes  = Array.from(section.querySelectorAll('[data-wg-info]'));

    if (!cards.length || !track) return;

    var total   = cards.length;
    var current = 0;

    /* ── Geometry ── */
    var ACTIVE_W = 0.34;   /* fraction of section width — taller portrait-ish card */
    var SIDE_W   = 0.17;
    var GAP      = 16;

    function computePositions() {
      var sw  = section.offsetWidth;
      var cx  = sw / 2;
      var cw  = Math.round(sw * ACTIVE_W);
      var sw2 = Math.round(sw * SIDE_W);
      return { sw: sw, cx: cx, cw: cw, sw2: sw2 };
    }

    function layoutCards(animate) {
      var g = computePositions();
      cards.forEach(function (card, i) {
        var offset   = i - current;
        var absOff   = Math.abs(offset);
        var centre   = offset === 0;
        var w        = centre ? g.cw : g.sw2;
        var x;
        if (centre) {
          x = g.cx - g.cw / 2;
        } else if (offset > 0) {
          x = g.cx + g.cw / 2 + GAP + (offset - 1) * (g.sw2 + GAP);
        } else {
          x = g.cx - g.cw / 2 - GAP - (-offset - 1) * (g.sw2 + GAP) - g.sw2;
        }
        var opacity = absOff > 2 ? 0 : centre ? 1 : 0.48;
        var scale   = centre ? 1 : 0.91;
        var zIdx    = centre ? 3 : Math.max(0, 3 - absOff);
        var inner   = card.querySelector('.wg__card-img-wrap');
        var d       = animate ? 0.7 : 0;
        var e       = 'power3.out';
        var p       = { x: x, width: w, scale: scale, opacity: opacity, zIndex: zIdx, duration: d, ease: e, overwrite: true };
        animate ? gsap.to(card, p) : gsap.set(card, p);
        if (inner) {
          var ip = { xPercent: centre ? 0 : offset * -5, duration: d, ease: e, overwrite: true };
          animate ? gsap.to(inner, ip) : gsap.set(inner, ip);
        }
        card.classList.toggle('is-active', centre);
      });
    }

    /* ── Update centre caption ── */
    function updateCaption(idx, isFirst) {
      var node = infoNodes[idx];
      var lbl  = node ? node.querySelector('[data-wg-info-label]').textContent  : '';
      var cap  = node ? node.querySelector('[data-wg-info-caption]').textContent : '';

      if (isFirst || !window.gsap || !centreInfo) {
        if (centreLabel) centreLabel.textContent = lbl;
        if (centreCap)   centreCap.textContent   = cap;
        return;
      }

      gsap.to(centreInfo, {
        opacity: 0, y: -10, duration: 0.2, ease: 'power2.in',
        onComplete: function () {
          if (centreLabel) centreLabel.textContent = lbl;
          if (centreCap)   centreCap.textContent   = cap;
          gsap.fromTo(centreInfo,
            { opacity: 0, y: 20 },
            { opacity: 1, y: 0,  duration: 0.55, ease: 'power3.out' }
          );
        }
      });
    }

    /* ── Update ghost number ── */
    function updateGhost(idx, isFirst) {
      var num = (idx + 1 < 10 ? '0' : '') + (idx + 1);
      if (isFirst || !window.gsap || !ghostEl) {
        if (ghostEl) ghostEl.textContent = num;
        return;
      }
      gsap.to(ghostEl, {
        opacity: 0, duration: 0.15, ease: 'power2.in',
        onComplete: function () {
          ghostEl.textContent = num;
          gsap.to(ghostEl, { opacity: 1, duration: 0.3, ease: 'power2.out' });
        }
      });
    }

    /* ── Update counter + dots ── */
    function updateUI(idx, isFirst) {
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      if (counterEl && window.gsap && !isFirst) {
        gsap.to(counterEl, { opacity: 0, y: -5, duration: 0.15, ease: 'power2.in',
          onComplete: function () {
            counterEl.textContent = (idx + 1 < 10 ? '0' : '') + (idx + 1);
            gsap.to(counterEl, { opacity: 1, y: 0, duration: 0.2, ease: 'power2.out' });
          }
        });
      } else if (counterEl) {
        counterEl.textContent = (idx + 1 < 10 ? '0' : '') + (idx + 1);
      }
    }

    /* ── Go to index ── */
    function goTo(idx) {
      idx = ((idx % total) + total) % total;
      if (idx === current) return;
      current = idx;
      layoutCards(true);
      updateCaption(idx, false);
      updateGhost(idx, false);
      updateUI(idx, false);
    }

    /* ── Click card to centre it ── */
    cards.forEach(function (card, i) {
      card.addEventListener('click', function () {
        if (i !== current) goTo(i);
      });
    });

    /* ── Keyboard ── */
    document.addEventListener('keydown', function (e) {
      var r = section.getBoundingClientRect();
      if (r.top > window.innerHeight || r.bottom < 0) return;
      if (e.key === 'ArrowRight') goTo(current + 1);
      if (e.key === 'ArrowLeft')  goTo(current - 1);
    });

    /* ── Drag ── */
    var dragStartX = 0;
    var dragging   = false;
    var hasMoved   = false;
    var SNAP_PX    = 70;

    function onStart(x) { dragStartX = x; dragging = true; hasMoved = false; }
    function onMove(x) {
      if (!dragging) return;
      if (Math.abs(x - dragStartX) > 6) hasMoved = true;
      if (!hasMoved) return;
      var nudge = (x - dragStartX) * 0.1;
      var g = computePositions();
      cards.forEach(function (card, i) {
        var offset = i - current;
        var absOff = Math.abs(offset);
        var centre = offset === 0;
        var w  = centre ? g.cw : g.sw2;
        var bx = centre
          ? g.cx - g.cw / 2
          : offset > 0
            ? g.cx + g.cw / 2 + GAP + (offset - 1) * (g.sw2 + GAP)
            : g.cx - g.cw / 2 - GAP - (-offset - 1) * (g.sw2 + GAP) - g.sw2;
        if (absOff <= 2) gsap.set(card, { x: bx + nudge });
      });
      if (trackWrap) trackWrap.classList.add('is-dragging');
    }
    function onEnd(x) {
      if (!dragging) return;
      dragging = false;
      if (trackWrap) trackWrap.classList.remove('is-dragging');
      var dx = x - dragStartX;
      if (hasMoved && Math.abs(dx) > SNAP_PX) {
        goTo(dx < 0 ? current + 1 : current - 1);
      } else {
        layoutCards(true);
      }
    }

    var el = trackWrap || section;
    el.addEventListener('mousedown',  function (e) { onStart(e.clientX); });
    window.addEventListener('mousemove', function (e) { if (dragging) onMove(e.clientX); });
    window.addEventListener('mouseup',   function (e) { onEnd(e.clientX); });
    el.addEventListener('touchstart', function (e) { onStart(e.touches[0].clientX); }, { passive: true });
    el.addEventListener('touchmove',  function (e) { if (dragging) onMove(e.touches[0].clientX); }, { passive: true });
    el.addEventListener('touchend',   function (e) { onEnd(e.changedTouches[0].clientX); });

    /* ── Resize ── */
    window.addEventListener('resize', function () {
      if (!isMobile) layoutCards(false);
    });

    /* ── Init layout + entry animation ── */
    gsap.registerPlugin(ScrollTrigger);
    gsap.set(track, { position: 'relative' });
    cards.forEach(function (c) { gsap.set(c, { position: 'absolute', top: 0, height: '100%' }); });
    layoutCards(false);
    updateCaption(0, true);
    updateGhost(0, true);
    /* Hide via GSAP so entrance animation works — CSS guard removed for centreInfo */
    if (centreInfo) gsap.set(centreInfo, { opacity: 0, x: -16 });

    /* Cards enter rising from below */
    ScrollTrigger.create({
      trigger: section, start: 'top 78%', once: true,
      onEnter: function () {
        section.classList.add('wg--ready');
        var eyebrow = section.querySelector('[data-wg-eyebrow]');
        if (eyebrow) gsap.from(eyebrow, { opacity: 0, y: 10, duration: 0.5, ease: 'power3.out' });
        cards.forEach(function (card, i) {
          var offset = i - current;
          gsap.from(card, {
            opacity: 0, y: 80, duration: 0.8,
            delay: 0.05 + Math.abs(offset) * 0.09,
            ease: 'power3.out'
          });
        });
        if (centreInfo) gsap.to(centreInfo, { opacity: 1, x: 0, duration: 0.6, delay: 0.35, ease: 'power3.out' });
        if (ghostEl)    gsap.from(ghostEl,    { opacity: 0, duration: 0.5, delay: 0.45, ease: 'power2.out' });
        var bottombar = section.querySelector('.wg__bottombar');
        if (bottombar) gsap.from(bottombar, { opacity: 0, y: 16, duration: 0.5, delay: 0.4, ease: 'power3.out' });
      }
    });
  }

  /* ================================================================
     MOBILE — exact original image-trail 3D coverflow (unchanged logic)
  ================================================================ */
  function initMobile() {
    if (!isMobile) return;

    var carousel = section.querySelector('[data-trail-carousel]');
    var slides   = section.querySelectorAll('[data-trail-slide]');
    var dots     = section.querySelectorAll('.wg__mob-dot');

    if (!carousel || !slides.length || window.innerWidth >= 768) return;

    var total    = slides.length;
    var current  = 0;
    var startX   = 0;
    var dragX    = 0;
    var dragging = false;

    var SPREAD_X    = 75;
    var ROTATE_Y    = 38;
    var SCALE_OFF   = 0.72;
    var TRANS_Z     = -140;
    var OPACITY_OFF = 0.45;

    gsap.set(carousel, { perspective: 900, perspectiveOrigin: '50% 50%' });

    var track = section.querySelector('[data-trail-track]');
    if (track) {
      gsap.set(track, { position: 'relative', width: '100%', height: '100%', transformStyle: 'preserve-3d' });
    }

    slides.forEach(function (slide) {
      gsap.set(slide, { position: 'absolute', top: '50%', left: '50%', xPercent: -50, yPercent: -50, transformStyle: 'preserve-3d' });
    });

    function layout(animate) {
      slides.forEach(function (slide, i) {
        var offset  = i - current;
        var clamp   = Math.max(-3, Math.min(3, offset));
        var props = {
          x:        clamp * SPREAD_X,
          rotateY:  clamp * -ROTATE_Y,
          scale:    Math.max(0.3, clamp === 0 ? 1 : SCALE_OFF - Math.abs(clamp) * 0.04),
          z:        clamp === 0 ? 0 : TRANS_Z - Math.abs(clamp) * 20,
          opacity:  Math.max(0, clamp === 0 ? 1 : OPACITY_OFF - Math.abs(clamp) * 0.08),
          zIndex:   10 - Math.abs(clamp),
          duration: animate ? 0.55 : 0,
          ease:     'power3.out',
          overwrite: true
        };
        animate ? gsap.to(slide, props) : gsap.set(slide, props);
      });
      dots.forEach(function (dot, i) { dot.classList.toggle('active', i === current); });
    }

    function goTo(idx) {
      current = ((idx % total) + total) % total;
      layout(true);
    }

    carousel.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX; dragging = true; e.stopPropagation();
    }, { passive: true });

    carousel.addEventListener('touchmove', function (e) {
      if (!dragging) return; e.stopPropagation();
      dragX = e.touches[0].clientX - startX;
      slides.forEach(function (slide, i) {
        var clamp = Math.max(-3, Math.min(3, i - current));
        gsap.set(slide, { x: clamp * SPREAD_X + dragX * 0.25 });
      });
    }, { passive: true });

    carousel.addEventListener('touchend', function (e) {
      if (!dragging) return;
      dragging = false; e.stopPropagation();
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) goTo(dx < 0 ? current + 1 : current - 1);
      else layout(true);
      dragX = 0;
    });

    /* Stagger slides in on scroll enter — exact original behaviour */
    ScrollTrigger.create({
      trigger: section, start: 'top 85%', once: true,
      onEnter: function () {
        slides.forEach(function (slide, i) {
          gsap.set(slide, { opacity: 0, x: 120, rotateY: -20, scale: 0.7 });
          gsap.to(slide, {
            opacity: 1, x: 0, rotateY: 0, scale: 1,
            duration: 0.7, delay: i * 0.07, ease: 'power3.out',
            onComplete: i === total - 1 ? function () { layout(true); } : null
          });
        });
      }
    });

    layout(false);
  }

  /* ── Init ── */
  function init() {
    gsap.registerPlugin(ScrollTrigger);
    initDesktop();
    initMobile();
  }

  if (window.gsap) init();
  else window.addEventListener('load', init);

})();
